"use strict";

exports.__esModule = true;
var _Layout = require("./Layout");
Object.keys(_Layout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Layout[key]) return;
  exports[key] = _Layout[key];
});